export default __webpack_public_path__ + "static/media/heavy-horse.cd765304.jpg";